export default "__VITE_ASSET__DZI4_ZXo__"